/**
 * useVolumeHistory — Fetches trading volume time-series for a token.
 *
 * Story 8.3: Analytics Charts UI — Volume Trends & Holder Growth
 */

import type { PriceInterval } from "@repo/shared-types";
import { useQuery } from "@tanstack/react-query";
import { tokensApi } from "../../lib/api";
import { tokenKeys } from "./query-keys";

const STALE_TIMES: Record<PriceInterval, number> = {
	"1H": 30_000,
	"4H": 30_000,
	"1D": 60_000,
	"1W": 60_000,
};

export function useVolumeHistory(id: string, interval: PriceInterval) {
	return useQuery({
		queryKey: tokenKeys.volumeHistory(id, interval),
		queryFn: async () => {
			const response = await tokensApi.getVolumeHistory(id, interval);
			return response.data;
		},
		enabled: !!id,
		staleTime: STALE_TIMES[interval],
	});
}
